// @flow

import { connect } from 'react-redux';

import { UniversalNavProvider } from '@zapier/design-system-patterns';

import * as Account from 'app/entities/Account';
import * as RouterSelectors from 'app/common/utils/RouterSelectors';
import { getAccountSwitcherUrl } from 'app/common/middlewares/accountSwitcherMiddleware';

const mapStateToProps = state => {
  return {
    accountSwitcherUrl: getAccountSwitcherUrl(state),
    currentAccountId: Account.selectors.all.currentAccountId(state),
    currentUrl: RouterSelectors.currentUrl(state) || '',
  };
};

export default connect(mapStateToProps)(UniversalNavProvider);
